import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Tooltip from "@mui/material/Tooltip";

interface Props {
  tooltip?: string;
}

export function AddButton(props: IconButtonProps & Props) {
  const { t } = useTranslation();
  const { tooltip, ...rest } = props;

  return (
    <Tooltip title={<div>{tooltip || t("common.add")}</div>}>
      <IconButton color="primary" {...rest} size="large">
        <AddCircleIcon color="primary" />
      </IconButton>
    </Tooltip>
  );
}
